// Mapper: transport LC_GetMyTeamMonthlyEvolutionOut → domain model for the "Mi equipo"
// dashboard "Resumen del mes" bar charts (ASIS-5413 / REXASIS-012).
// Direct 1:1 mapping of the 3 series — unlike the summary cards, there is no
// percentage/isEmpty business rule to compute here, the backend already resolves each
// point (including the value: 0 fallback for months without data).

import type {
  LC_GetMyTeamMonthlyEvolutionOut,
  LC_MonthlyEvolutionPointOut,
  MyTeamMonthlyEvolution,
  MyTeamMonthlyEvolutionPoint,
} from '../types/myTeamMonthlyEvolution.types';


const mapPoint = (point: LC_MonthlyEvolutionPointOut): MyTeamMonthlyEvolutionPoint => ({
  year: point.year,
  month: point.month,
  value: point.value,
});

export function mapMyTeamMonthlyEvolution(
  out: LC_GetMyTeamMonthlyEvolutionOut,
): MyTeamMonthlyEvolution {
  return {
    overtimeSeries: out.overtimeSeries.map(mapPoint),
    tardinessSeries: out.tardinessSeries.map(mapPoint),
    absenceSeries: out.absenceSeries.map(mapPoint),
  };
}
